/* MUI */
import { useTheme } from '@mui/material/styles';

/* React */
import React from 'react';

export const DeployAgentInsteadGraphic = () => {
    const theme = useTheme();

    return (
        <svg
            width="400"
            height="240"
            viewBox="0 0 400 240"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                width="400"
                height="240"
                rx="6.66667"
                fill={
                    theme.palette.onboarding.deployAgentInsteadGraphic
                        .backgroundColor.light
                }
            />
            <path
                d="M0 6.66667C0 2.98477 2.98477 0 6.66667 0H393.333C397.015 0 400 2.98477 400 6.66667V48H0V6.66667Z"
                fill={
                    theme.palette.onboarding.deployAgentInsteadGraphic
                        .backgroundColor.medium
                }
            />
            <rect
                x="16"
                y="18.0002"
                width="72"
                height="12"
                rx="6"
                fill={
                    theme.palette.onboarding.deployAgentInsteadGraphic
                        .backgroundColor.dark
                }
            />
            <rect
                x="112"
                y="18.0002"
                width="120"
                height="12"
                rx="6"
                fill={
                    theme.palette.onboarding.deployAgentInsteadGraphic
                        .backgroundColor.dark
                }
            />
            <rect
                x="256"
                y="18.0002"
                width="128"
                height="12"
                rx="6"
                fill={
                    theme.palette.onboarding.deployAgentInsteadGraphic
                        .backgroundColor.dark
                }
            />
            <path
                // eslint-disable-next-line max-len
                d="M187.52 162.582V158.246C187.52 155.59 187.891 153.246 188.633 151.215C189.375 149.145 190.566 147.191 192.207 145.355C193.848 143.48 196.016 141.566 198.711 139.613C201.133 137.895 203.066 136.352 204.512 134.984C205.996 133.617 207.07 132.27 207.734 130.941C208.438 129.574 208.789 128.031 208.789 126.312C208.789 123.773 207.852 121.84 205.977 120.512C204.102 119.184 201.484 118.52 198.125 118.52C194.766 118.52 191.426 119.047 188.105 120.102C184.824 121.156 181.484 122.543 178.086 124.262L171.699 111.43C175.605 109.242 179.844 107.484 184.414 106.156C188.984 104.789 193.984 104.105 199.414 104.105C207.773 104.105 214.238 106.117 218.809 110.141C223.418 114.125 225.723 119.203 225.723 125.375C225.723 128.656 225.195 131.508 224.141 133.93C223.125 136.312 221.562 138.539 219.453 140.609C217.383 142.641 214.785 144.789 211.66 147.055C209.316 148.773 207.52 150.219 206.27 151.391C205.02 152.562 204.16 153.734 203.691 154.906C203.262 156.039 203.047 157.426 203.047 159.066V162.582H187.52ZM185.645 182.621C185.645 178.949 186.641 176.371 188.633 174.887C190.664 173.402 193.105 172.66 195.957 172.66C198.73 172.66 201.113 173.402 203.105 174.887C205.137 176.371 206.152 178.949 206.152 182.621C206.152 186.137 205.137 188.676 203.105 190.238C201.113 191.801 198.73 192.582 195.957 192.582C193.105 192.582 190.664 191.801 188.633 190.238C186.641 188.676 185.645 186.137 185.645 182.621Z"
                fill={theme.palette.onboarding.tertiaryIconColor}
            />
        </svg>
    );
};
